const trimTrailingSlash = value => value.replace(/\/+$/, '');

const rtcEnvironment = {
    baseUrl: process.env.REACT_APP_RTC_BASE_URL,
    websocketPort: process.env.REACT_APP_RTC_PORT_WEBSOCKET,
    ivrPort: process.env.REACT_APP_RTC_PORT_IVR,
    smsPort: process.env.REACT_APP_RTC_PORT_SMS,
    callForwardPort: process.env.REACT_APP_RTC_PORT_CALL_FORWARD,
    patchPort: process.env.REACT_APP_RTC_PORT_PATCH,
    cstaPort: process.env.REACT_APP_RTC_PORT_CSTA,
};

Object.keys(rtcEnvironment).forEach(key => {
    if (!rtcEnvironment[key]) {
        throw new Error(`Missing RTC environment setting: ${key}`);
    }
});

export const RTC_BASE_URL = trimTrailingSlash(rtcEnvironment.baseUrl);
export const RTC_PORT_WEBSOCKET = rtcEnvironment.websocketPort;
export const RTC_PORT_IVR = rtcEnvironment.ivrPort;
export const RTC_PORT_SMS = rtcEnvironment.smsPort;
export const RTC_PORT_CALL_FORWARD = rtcEnvironment.callForwardPort;
export const RTC_PORT_PATCH = rtcEnvironment.patchPort;
export const RTC_PORT_CSTA = rtcEnvironment.cstaPort;

export const rtcHttpUrl = (port, path = '') => `${RTC_BASE_URL}:${port}${path}`;
export const rtcWebSocketUrl = (port = RTC_PORT_WEBSOCKET) =>
    `${RTC_BASE_URL.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:')}:${port}`;

export const RTC_WEBSOCKET_URL = rtcWebSocketUrl();
export const RTC_WEBSOCKET_HTTP_URL = rtcHttpUrl(RTC_PORT_WEBSOCKET);
export const RTC_IVR_URL = rtcHttpUrl(RTC_PORT_IVR);
export const RTC_SMS_URL = rtcHttpUrl(RTC_PORT_SMS);
export const RTC_CALL_FORWARD_URL = rtcHttpUrl(RTC_PORT_CALL_FORWARD);
export const RTC_PATCH_URL = rtcHttpUrl(RTC_PORT_PATCH);
export const RTC_CSTA_URL = rtcHttpUrl(RTC_PORT_CSTA);
